import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { FormattedDate, injectIntl } from 'react-intl'
import { currentAlbumSelector } from '../../../../redux/selectors'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import { Button, Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { goToAlbumView, markImageAsRead } from '../../../../redux/actions'
import GetAppIcon from '@material-ui/icons/GetApp';
import ImageWithLoading from '../../../../components/ImageWithLoading'
import Container from '@material-ui/core/Container';
import ReactVisibilitySensor from 'react-visibility-sensor'
import BorderLinearProgress from '../../../../components/ProgressBar'
import { getUser } from '../../../../utilties/userUtilities'

const useStyles = makeStyles((theme) => ({
	root: {
		color: 'white',
		fontSize: '17px',
		fontWeight: '800',
		padding: '32px 0 8px',
		textAlign: 'left'
	},
	titleRoot: {
		fontSize: '32px',
		fontWeight: 'normal',
		textAlign: 'left',
		letterSpacing: '0.25px',
		marginBottom: '4px',
		[theme.breakpoints.down('sm')]: {
			fontSize: '24px',
		},			
	},
	titleDate: {
		fontSize: '16px',
		fontWeight: '800',
		textAlign: 'left',
	},
	imageDate: {
		fontSize: '16px',
		fontWeight: '400',
		textAlign: 'left',
		marginBottom: '5px'
	},
	imageNew: {
		color: '#02DC94',
		fontSize: '16px',
		fontWeight: '400',
		textAlign: 'left',
		marginBottom: '5px'
	},
	fullAlbomWrapper: {
		width: '70%', 
		margin: '0 auto',
		[theme.breakpoints.down('sm')]: {
			width: '100%', 
		},		
	},
	backLink: {
		paddingBottom: '50px', 
		[theme.breakpoints.down('sm')]: {
			paddingBottom: '30px',
		},		
	},
	imagesMainBackground: {
		backgroundColor: '#000', 
	},
	summaryProgressCount: {
		fontSize: '16px',
		fontWeight: 'bold',
		display: 'inline',
		marginRight: '8px'
	},
	summaryProgressText: {
		fontSize: '16px',
		fontWeight: 200,
		display: 'inline'
	},
	buttonDownload: {
		maxHeight: '36px', 
		maxWidth: '36px', 
		minHeight: '36px', 
		minWidth: '36px', 
		position: 'absolute', 
		transform: 'translate(-120%, 20%)', 
		"&.Mui-focusVisible:not(.MuiMenuItem-root.MuiMenuItem-gutters.MuiListItem-gutters.MuiListItem-button):focus": {
			outline: '2px #5fe5ff solid !important'
		}
	}
}))

const Images = ({ intl, currentAlbum, isExternalAuth, returnToAlbums, markAsRead }) => {
	const [ markAsReadSent, setMarkAsReadSent] = useState([])
	const [ markAsReadTimer, setMarkAsReadTimer] = useState(null)
	const user = getUser()

	const classes = useStyles()

	const onMarkAsRead = (id) => {
		if (!!user && !user.externalAuth) {
			setMarkAsReadSent([...markAsReadSent, id])
			markAsRead(id)
		}
	}

	const onVisibilityChange = (isVisible, image) => {
		if (image && image.isNew && !markAsReadSent.find(x => x === image.id)) {
			if (isVisible) {
				setMarkAsReadTimer({...markAsReadTimer, [image.id]: setTimeout(() => onMarkAsRead(image.id), 3000)})
			} else if(markAsReadTimer) {
				clearTimeout(markAsReadTimer[image.id])
			}
		}
	}

	const calculateProgress = () => {
		return currentAlbum.totalCount && currentAlbum.images ? currentAlbum.images.length * 100 / currentAlbum.totalCount : 0
	}

	const goBack = () => {
		returnToAlbums()
	}

	const onImageLoad = (index, id) => {
		var button = document.getElementById(`downloadBtn-${index}`);
		if(button){
			button.style.display = ""
		}
	} 

	let randomPart = Date.now();

	const downloadImage = (image) => {
		var element = document.createElement('a')
		element.setAttribute('href', image.url)
		element.setAttribute('download', image.fileName)

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)
	}

	return (
		<div className={`${classes.imagesMainBackground} patient-images-main`} style={{ width: '100%' }}>
			<Container maxWidth="lg" className={`${classes.imagesMainBackground} patient-images-main`} data-testid="albums-images-container">
				{currentAlbum &&
					<Grid container className={`${classes.root} patient-images-root`}>
						<Grid item xs={12} className={classes.backLink} data-print="none">
							<Typography data-testid="albums-images-container-back" style={{ fontSize: '16px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }} onClick={goBack}>
								<ArrowBackIcon style={{ fontSize: '24px', paddingRight: '10px' }} />
								{intl.formatMessage({ id: 'app.case.images.back' })}
							</Typography>
						</Grid>
						<Grid item xs={12} style={{ paddingBottom: '20px' }}>
							<Grid container className={`${classes.fullAlbomWrapper} full-albom-wrapper`}>
								<Grid item xs={12} style={{ paddingBottom: '20px' }}>
								<BorderLinearProgress
										aria-label={intl.formatMessage({ id: 'app.case.images.progress' })}
									data-testid="case-summary-progress-bar"
									id="ProgressBar"
									variant="determinate" value={calculateProgress()} style={{ width: '100%' }} />
								<label for="ProgressBar">
									<Typography data-testid="case-summary-progress-count" className={classes.summaryProgressCount}>
										{`${currentAlbum.images.length ?? 0} / ${currentAlbum.totalCount}`}
									</Typography>
									<Typography data-testid="case-summary-progress-title" className={classes.summaryProgressText}>
										{intl.formatMessage({ id: 'app.case.images.progress' })}
									</Typography>
								</label>
								</Grid>

								<Grid item xs={12} style={{ paddingBottom: '20px' }}>
									<Typography data-testid="albums-images-container-title" variant='h2' className={classes.titleRoot}>
										{currentAlbum.title}
									</Typography>

									<Typography data-testid="albums-images-container-date" variant='body1' className={classes.titleDate}>
										<FormattedDate year='numeric' month='long' day='2-digit' value={currentAlbum.firstCompletedDate} />
										{' - '}
										<FormattedDate year='numeric' month='long' day='2-digit' value={currentAlbum.lastCompletedDate} />
									</Typography>
								</Grid>
								{currentAlbum.images.map((image, index) => (
									<ReactVisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, image)} partialVisibility={true} minTopValue={50}>
										<Grid item xs={12} style={{ paddingBottom: '50px' }} key={index} className={`${classes.imageItemWrapper} image-item-wrapper`}>
											{image.isNew &&
												<Typography data-testid="image-new" variant='h4' className={classes.imageNew} >
													<div style={{
														height: '10px',
														width: '10px',
														backgroundColor: '#02DC94',
														borderRadius: '50%',
														display: 'inline-block',
														marginRight: '5px'
													}} />
													{intl.formatMessage({ id: 'app.case.images.new' })}
												</Typography>
											}
											<Typography data-testid="image-date" variant='h4' className={classes.imageDate}>
												<FormattedDate year='numeric' month='long' day='2-digit' value={image.completedDate} />
											</Typography>

											<div style={{ position: 'relative'}} >
												<ImageWithLoading
													data-testid="image-item"
													src={`${image.mediumThumbnailUrl ?? image.url}?${randomPart}`}
													style={{ width: '100%', maxWidth: '100%', maxHeight: '100%' }}
													customOnLoad={() => onImageLoad(index, image.id)}
												/>
												<Button
													data-testid="download-image-button"
													aria-label="Download image"
													id={`downloadBtn-${index}`}
													variant="contained"
													color="primary"
													className={classes.buttonDownload}
													style={{
														display: 'none' 
													}}
													onClick={() => downloadImage(image)}
													data-print="none"
												>
													<GetAppIcon style={{ fontSize: '20px', color: 'white' }} />
												</Button>
											</div>
										</Grid>
									</ReactVisibilitySensor>)
								)}
							</Grid>
						</Grid>
					</Grid>}
			</Container>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => ({
	currentAlbum: currentAlbumSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	returnToAlbums: () => dispatch(goToAlbumView()),
	markAsRead: (id) => dispatch(markImageAsRead(id))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(Images)
